import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import NotFoundImage from '@/shared/assets/not-found.svg';
import { NavLink } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

import { StyledBox, StyledText, StyledWrapper } from './styles';

export const NotFoundPage: FC = () => {
  const { t } = useTranslation();

  return (
    <StyledWrapper>
      <StyledBox>
        <StyledText>
          <div>{t('common:notFoundPage.noSuchPage')}</div>
          <CustomTypography sx={{ fontSize: '24px' }}>
            <Trans i18nKey="common:notFoundPage.returnToMainPage">
              Return to <NavLink to="/">main</NavLink> page
            </Trans>
          </CustomTypography>
        </StyledText>

        <NotFoundImage />
      </StyledBox>
    </StyledWrapper>
  );
};
